module.exports = __webpack_public_path__ + "static/annoucements-e01421195e9839947b1598290aa16f76.png";